/**
 * Valide les données du formulaire de contact et d'urgence
 * @param {Object} data - Les données du formulaire { nom, email, sujet, message, isUrgent, telephone }
 * @returns {{ isValid: boolean, errors: Object }}
 */
export function validateContactForm(data) {
  const errors = {};

  if (!data.nom || !data.nom.trim()) {
    errors.nom = "Le nom complet est obligatoire.";
  }

  if (!data.email || !data.email.trim()) {
    errors.email = "L'adresse email est obligatoire.";
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email.trim())) {
      errors.email = "L'adresse email saisie est invalide.";
    }
  }

  if (!data.sujet || !data.sujet.trim()) {
    errors.sujet = "L'objet / sujet du message est obligatoire.";
  }

  if (!data.message || !data.message.trim()) {
    errors.message = "Le contenu du message est obligatoire.";
  } else if (data.message.trim().length < 10) {
    errors.message = "Le message doit contenir au moins 10 caractères.";
  }

  // Si c'est un signalement d'urgence, le numéro de téléphone est fortement recommandé/obligatoire
  if (data.isUrgent) {
    if (!data.telephone || !data.telephone.trim()) {
      errors.telephone = "Un numéro de téléphone/WhatsApp est requis en cas d'urgence.";
    } else {
      const phoneRegex = /^\+?[0-9\s-]+$/;
      if (!phoneRegex.test(data.telephone.trim())) {
        errors.telephone = "Le numéro de téléphone est invalide.";
      }
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}
